<template>
  <div class="main-content-rt">
    <!-- <el-dialog :visible.sync="resultShow" width="80%" title="Результат" center append-to-body>
      <div v-if="!resultLog">{{getRTRetFile}}</div>
      <div v-for="(line, index) in resultLog" :key="index">{{line}}</div>
    </el-dialog>-->
    <div v-if="taskSelected.idTypeTask !== '99' || !!fromCron" v-shortkey="['ctrl', 'enter']" @shortkey="runTaskClick">
      <div class="main-form-scroll">
        <div v-for="(el, index) in getRTCmdLine" :key="index" class="line">
          <label v-if="showLabel(el)">{{ el.caption }}</label>

          <div v-if="el.ftParam === 'ftBoolean'">
            <el-checkbox v-model="formData[index]" @change="fieldChanged" :disabled="fieldDisabled">{{ el.caption
            }}</el-checkbox>
          </div>
          <div v-else-if="el.ftParam === 'ftBaseName'">
            <el-select v-model="formData[index]" v-if="!fromCron" filterable @change="fieldChanged"
              :disabled="fieldDisabled">
              <el-option v-for="(base, index) in getBasesInSection" :key="index" :value="base.bname"
                :label="baseLabel(base)"></el-option>
            </el-select>
          </div>
          <div v-else-if="el.ftParam === 'ftBaseShortName'">
            <el-select v-model="formData[index]" v-if="!fromCron" filterable @change="fieldChanged"
              :disabled="fieldDisabled">
              <el-option v-for="(base, index) in getBasesInSection" :key="index" :value="base.shortName"
                :label="baseLabel(base)"></el-option>
            </el-select>
          </div>
          <div v-else-if="el.ftParam === 'ftServer'">
            <el-select v-model="formData[index]" @change="fieldChanged" :disabled="fieldDisabled" filterable>
              <el-option v-for="(server, index) in getServersArray" :key="index" :value="server.id"
                :label="server.name"></el-option>
            </el-select>
          </div>
          <div v-else-if="el.ftParam === 'ftFile'">
            <!-- <input type="file" ref="fileInput" if="fileInput" @change="handleFileUpload" /> -->
            <el-upload action ref="fileInput" :auto-upload="false" :on-change="handleFileUpload">
              <el-button slot="trigger">{{
                $t("runTaskForm.fileSelect")
              }}</el-button>
            </el-upload>
          </div>
          <div v-else-if="el.ftParam === 'ftInteger' || el.ftParam === 'ftFloat'">
            <el-input v-model="formData[index]" type="number" @change="fieldChanged" :disabled="fieldDisabled"
              :maxlength="el.maxLength ? +el.maxLength : null"></el-input>
          </div>
          <div v-else-if="el.ftParam === 'ftDateTime'">
            <el-date-picker v-model="formData[index]" type="datetime" value-format="dd/MM/yyyy H:mm:ss"
              format="dd/MM/yyyy H:mm:ss" @change="fieldChanged" :disabled="fieldDisabled"></el-date-picker>
            <!-- <el-input v-model="formData[index]" type="datetime-local"></el-input> -->
          </div>
          <div v-else-if="el.ftParam === 'ftDate'">
            <el-date-picker v-model="formData[index]" type="date" value-format="dd/MM/yyyy" format="dd/MM/yyyy"
              @change="fieldChanged" :disabled="fieldDisabled"></el-date-picker>
          </div>
          <div v-else-if="el.ftParam === 'ftTime'">
            <el-time-picker v-model="formData[index]" @change="fieldChanged" :disabled="fieldDisabled" :picker-options="{
              format: 'H:mm:ss',
            }" format="H:mm:ss" value-format="H:mm:ss"></el-time-picker>
          </div>
          <div v-else-if="el.ftParam !== 'ftConst' &&
            el.ftParam !== 'ftAppHome' &&
            el.ftParam !== 'ftAppName'
            ">
            <el-input v-model="formData[index]" @change="fieldChanged" :disabled="fieldDisabled"
              :maxlength="el.maxLength ? +el.maxLength : null"></el-input>
          </div>
        </div>
        <div v-if="!fromCron">
          <label>{{ $t("runTaskForm.comment") }}</label>
          <el-input v-model="commentLine"></el-input>
        </div>
        <div v-else>
          {{ $t("runTaskForm.cmdLine") }}
          <div v-for="line in getRTCmdLine" :key="line.nn">
            {{ line.nn }} --- {{ line.ftParam }} --- {{ line.caption }}
          </div>
        </div>
        <!-- <buttons-files :disabled="disableFlag" :queueId="queueId"></buttons-files> -->
        <!--  <el-button @click="resultClick" class="dialog-btn" :disabled="disableFlag">Результат</el-button>
        <el-button @click="filesClick" class="dialog-btn" :disabled="disableFlag">Файлы</el-button>-->
        <!-- <el-button @click="helpClick" class="dialog-btn">Помощь</el-button> -->
      </div>
      <div class="task-text" v-if="!fromCron">
        <div v-if="taskRunsFlag === 1">
          <i class="el-icon-loading"></i> &nbsp;{{
            $t("runTaskForm.taskStarted")
          }}
        </div>
        <div v-else-if="taskRunsFlag === 2" :class="{
          'error-message': resultLine === 'ERROR',
          'success-message': resultLine !== 'ERROR',
        }">
          <i class="el-icon-check" v-if="resultLine !== 'ERROR'"></i>
          <i v-else class="el-icon-error"></i>&nbsp;
          {{ $t("runTaskForm.taskCompleted") }}
          <span v-if="resultLine === 'ERROR'">
            {{ $t("runTaskForm.withError") }}
          </span>
        </div>
      </div>
      <div class="dialog-btns">
        <result-log-button :disabled="disableFlag" :queueId="queueId" v-if="!fromCron"></result-log-button>
        <files-select class="dialog-btn" :disabled="disableFlag" :queueId="queueId" v-if="!fromCron"
          :autoDownload="startAutoDownload"></files-select>
      </div>
      <div class="buttons-bottom">
        <div>
          <el-tooltip effect="light" :content="$t('runTaskForm.taskHelp')" placement="bottom-start">
            <el-button type="plain" v-if="!fromCron" icon="el-icon-info" @click="helpClick"></el-button>
          </el-tooltip>
        </div>
        <div>
          <el-button type="plain" @click="cancelClick">
            <span>{{ $t("runTaskForm.close") }}</span>
            <!-- <span v-else>{{ $t("runTaskForm.cancel") }}</span> -->
          </el-button>
          <el-button @click="runTaskClick" :disabled="startDisabled" type="success" class="dialog-btn">
            <p v-if="!fromCron">{{ $t("runTaskForm.start") }}</p>
            <p v-else>{{ $t("runTaskForm.accept") }}</p>
          </el-button>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- Для вызова upgrade -->
      <div class="main-form-scroll" v-shortkey="['ctrl', 'enter']" @shortkey="runUpgClick">
        <div>
          <!-- <input
            type="file"
            class="run-upg-button"
            ref="upgInput"
            if="upgInput"
            @change="handleUpgUpload"
          /> -->
          <el-upload action ref="upgInput" :auto-upload="false" :limit="1" accept=".upg" :on-change="handleUpgUpload">
            <el-button slot="trigger">{{
              $t("runTaskForm.fileSelect")
            }}</el-button>
          </el-upload>
        </div>
        <div class="upg-line">
          <label>{{ $t("runTaskForm.dataBase") }}</label>
          <el-select v-model="baseUpgSelected" v-if="!!getBasesInSection" @change="fieldChanged" :disabled="fieldDisabled"
            class="update-select" filterable>
            <el-option value="all_bases" :label="$t('runTaskForm.launchOnAllBases')" default></el-option>
            <el-option v-for="(base, index) in getBasesInSection" :key="index" :value="base.bname"
              :label="baseLabel(base)"></el-option>
          </el-select>
        </div>
        <div v-if="!fromCron" class="upg-line">
          <label>{{ $t("runTaskForm.comment") }}</label>
          <el-input v-model="commentLine"></el-input>
        </div>
      </div>
      <!--   <el-button @click="resultClick" class="dialog-btn" :disabled="disableFlag">Результат</el-button>
      <el-button @click="filesClick" class="dialog-btn" :disabled="disableFlag">Файлы</el-button>-->
      <!-- <el-button @click="helpClick" class="dialog-btn">Помощь</el-button> -->
      <div class="all-buttons">
        <div class="task-text">
          <div v-if="taskRunsFlag === 1">
            <i class="el-icon-loading"></i>&nbsp;{{
              $t("runTaskForm.taskStarted")
            }}
          </div>
          <div v-else-if="taskRunsFlag === 2" :class="{
            'error-message': resultLine === 'ERROR',
            'success-message': resultLine !== 'ERROR',
          }">
            <i class="el-icon-check" v-if="resultLine !== 'ERROR'"></i>
            <i v-else class="el-icon-error"></i>&nbsp;
            {{ $t("runTaskForm.taskCompleted") }}
            <span v-if="resultLine === 'ERROR'">
              {{ $t("runTaskForm.withError") }}
            </span>
          </div>
        </div>
        <div class="dialog-btns">
          <result-log-button :disabled="disableFlag" :queueId="queueId"></result-log-button>
          <files-select class="dialog-btn" :disabled="disableFlag" :queueId="queueId"></files-select>
        </div>
        <div class="buttons-bottom">
          <el-tooltip effect="light" :content="$t('runTaskForm.taskHelp')" placement="bottom-start">
            <el-button type="plain" icon="el-icon-info" @click="helpClick"></el-button>
          </el-tooltip>
          <div>
            <el-button @click="cancelClick" type="plain">
              <!-- <span v-if="queueId">Отменить</span> -->
              <span>{{ $t("runTaskForm.close") }}</span>
            </el-button>
            <el-button @click="runUpgClick" :disabled="startDisabled" type="success" class="dialog-btn">{{
              $t("runTaskForm.start") }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FilesSelect from "./FilesSelect";
import ResultLogButton from "./ResultLogButton";
import parseZombieMixin from "./parseZombiesMixin";
export default {
  // props: ["taskSelected", "fromCron"],
  props: {
    taskSelected: {
      type: Object,
      default() {
        return { idTypeTask: "1" };
      },
    },
    fromCron: { type: Boolean, default: false },
    autoDownload: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [parseZombieMixin],
  data() {
    return {
      formData: [],
      fieldDisabled: false,
      commentLine: "",
      filesArray: [],
      upgFile: null,
      baseUpgSelected: "all_bases",
      disableFlag: true,
      startAutoDownload: false,
      startDisabled: false,
      queueId: null,
      // 0 -- not started, 1 -- is running, 2 -- has finished
      taskRunsFlag: 0,
      resultLine: null,
    };
  },
  methods: {
    runTaskClick() {
      if (!this.fromCron) this.startDisabled = true;
      //вставление заранее известных параметров (приведение под тип)
      let filesArrayIndex = 0;
      let isValidated = true;
      this.getRTCmdLine.forEach((line) => {
        const index = line.nn - 1;
        const regExpString = new RegExp("[`'|&;$<>]");
        const regExpNumber = new RegExp("^\\d+$");
        const regExpFloat = new RegExp("^([+-]?.\\d+)|([+-]?\\d+(.\\d+)?)$");

        switch (line.ftParam) {
          case "ftConst":
            this.formData[index] = line.prompt;
            break;
          case "ftAppHome":
            if (!!this.fromCron) {
              this.formData[index] = "{{AppHome}}";
            } else this.formData[index] = this.getCurInfo.path;
            break;
          case "ftAppName":
            if (!!this.fromCron) {
              this.formData[index] = "{{AppName}}";
            } else this.formData[index] = this.getCurInfo.name;
            break;
          case "ftBaseShortName":
            //берем только имя базы до знака @
            if (!!this.fromCron) {
              this.formData[index] = "{{BaseShortName}}";
            } else if (this.formData[index])
              this.formData[index] = this.formData[index].split("@")[0];
            else isValidated = false;
            break;
          case "ftBaseName":
            if (!!this.fromCron) {
              this.formData[index] = "{{BaseName}}";
            } else if (this.formData[index])
              this.formData[index] = this.formData[index];
            else isValidated = false;
            break;
          case "ftBoolean":
            if (this.formData[index] == null) this.formData[index] = false;
            // this.formData[index] = this.formData[index] ? "1" : "0";
            break;
          case "ftFile":
            if (this.filesArray[filesArrayIndex]) {
              this.formData[index] =
                "[$$]" + this.filesArray[filesArrayIndex].name;
              //formData.append('upload', this.filesArray[filesArrayIndex]);
              filesArrayIndex++;
            } else {
              this.$store.commit(
                "setError",
                this.$t("runTaskForm.fileMustBePresent")
              );
              isValidated = false;
            }
            break;
          case "ftString":
            //console.log(this.formData[index]);
            if (this.formData[index] != null)
              this.formData[index] = this.formData[index].trim();
            else isValidated = false;
            break;
          case "ftInteger":
            //console.log(this.formData[index]);
            //console.log(typeof this.formData[index]);
            //console.log(regExpNumber);
            //console.log(regExpNumber.test(this.formData[index]));
            if (!regExpNumber.test(this.formData[index])) {
              this.$store.commit(
                "setError",
                `${this.$t("runTaskForm.fileMustBePresent")} ${index + 1}`
              );
              isValidated = false;
            }
            break;
          case "ftFloat":
            if (!regExpFloat.test(this.formData[index])) {
              this.$store.commit(
                "setError",
                `${this.$t("runTaskForm.inappropriateFloatFormat")} ${index + 1
                }`
              );
              isValidated = false;
            }
            break;
        }
      });
      //   //console.log(this.formData);
      if (isValidated) {
        let paramLine = "";
        let notEmpty = true;
        for (let i = 0; i < this.formData.length; i++) {
          const param = this.formData[i];
          const ftParam = this.getRTCmdLine[i].ftParam;
          if (param != null) {
            if (ftParam === "ftBoolean") {
              paramLine += `'${param ? "1" : "0"}' `;
            } else paramLine += `'${param}' `;
          } else {
            this.$store.commit(
              "setError",
              this.$t("runTaskForm.inappropriateFloatFormat")
            );
            notEmpty = false;
          }
        }

        this.taskRunsFlag = 1;
        paramLine = paramLine.trim();
        // console.log(paramLine);
        if (notEmpty && !this.fromCron) {
          this.fieldDisabled = true;
          this.$store
            .dispatch("execRunTask", {
              formData: this.createFormData(paramLine),
              // timeout: this.taskSelected.timeout,
              caption: this.taskSelected.caption,
            })
            .then(({ queue }) => {
              this.queueId = queue;
              this.$store.dispatch("getQueueTaskById", queue).then((result) => {
                this.disableFlag = false;
                this.taskRunsFlag = 2;
                this.fieldDisabled = false;
                if (result.qResultLog === "ERROR") {
                  this.resultLine = "ERROR";
                }
                if (this.autoDownload) {
                  this.startAutoDownload = true;
                }
              });
              // this.formData = [];
              this.commentLine = "";
              // this.filesArray = [];
            })
            .catch((error) => {
              console.error(error);
              this.taskRunsFlag = 0;
              if (error === "You are not allowed type task these operations")
                this.cancelClick();
            });
        } else if (!!this.fromCron) {
          this.$emit("paramLine", paramLine);
        }
      } else {
        this.$store.commit(
          "setError",
          this.$t("runTaskForm.checkFieldsContent")
        );
      }
    },
    runUpgClick() {
      // console.log(this.upgFile);
      // console.log(paramLine, this.baseUpgSelected);
      if (!this.upgFile || !this.baseUpgSelected) {
        this.$store.commit(
          "setError",
          this.$t("runTaskForm.oneOrAllFieldsNotFilled")
        );
        return;
      }
      // console.log(this.getCurInfo);
      let typeApi = this.getTypeApi.find(
        (type) => type.typeApiID === this.getCurInfo.idTypeAPI
      ).typeApiName;
      let upgType = this.upgFile.name.split(".")[0];
      let fileName = this.upgFile.name;
      if (typeApi.toLowerCase() !== upgType.toLowerCase()) {
        if (typeApi.toLowerCase() === "admin") {
          fileName = "admin." + fileName;
          this.$message(this.$t("runTaskForm.noAppTypeInFileName"));
        } else {
          this.$store.commit(
            "setError",
            this.$t("runTaskForm.uncorrectFileForAppRefresh")
          );
          return;
        }
      }
      let filename = `'[$$]${fileName}'`;
      this.startDisabled = true;
      // `'${this.baseUpgSelected}'` +
      // this.$emit("input", this.createFormData(paramLine));
      this.taskRunsFlag = 1;
      this.fieldDisabled = true;
      this.$store
        .dispatch("execRunTask", {
          formData: this.creatUpgFormData(
            filename,
            this.upgFile,
            this.baseUpgSelected
          ),
          // timeout: this.taskSelected.timeout,
          caption: this.taskSelected.caption,
        })
        .then(({ queue, clean }) => {
          this.queueId = queue;
          this.parseZombies(clean, false);
          this.$store.dispatch("getQueueTaskById", queue).then((result) => {
            this.disableFlag = false;
            this.taskRunsFlag = 2;
            if (result.qResultLog === "ERROR") {
              this.resultLine = "ERROR";
            }
            if (
              this.getTypeApi.find(
                (type) => type.typeApiID === this.getCurInfo.idTypeAPI
              ).typeApiName === "admin"
            )
              this.$message(this.$t("runTaskForm.plsRefreshPage"));
            this.fieldDisabled = false;
          });
          this.disableFlag = false;
          this.commentLine = "";
        })
        .catch((error) => {
          if (error.clean && error.busy) {
            this.parseZombies(error.clean);
            let runningUpgString = "";
            for (const upg of error.busy[0].upg) {
              runningUpgString += `${this.$t("multiTask.upgrade")}:${upg.taskParams
                } \n`;
            }
            this.$alert(runningUpgString, this.$t("multiTask.working"), {
              confirmButtonText: "OK",
            });
          } else {
            console.error(error);
            this.taskRunsFlag = 0;
            if (error === "You are not allowed type task these operations")
              this.cancelClick();
          }
        });
    },
    helpClick() {
      this.$store
        .dispatch("getHelp", this.taskSelected.idTask)
        .then((result) => {
          if (result) this.$message(result);
          else this.$message(this.$t("runTaskForm.noHelpOnThisTaskCtrlEnter"));
        })
        .catch((error) => console.error(error));
    },
    fieldChanged() {
      // console.log("Field changed");
      if (!this.fromCron && this.startDisabled) {
        //поменяли значение поля выбора
        this.resetForm();
      }
    },
    cancelClick() {
      this.formData = [];
      this.commentLine = "";
      this.taskRunsFlag = 0;
      this.filesArray = [];
      this.resetForm();
      this.$emit("close");
    },
    handleFileUpload() {
      //console.log(this.$refs.fileInput[0]);
      this.filesArray.push(this.$refs.fileInput[0].uploadFiles[0].raw);
      if (this.startDisabled) {
        this.resetForm();
      }
    },
    handleUpgUpload() {
      //console.log(this.$refs.upgInput);
      this.upgFile = this.$refs.upgInput.uploadFiles[0].raw;
      if (this.startDisabled && this.queueId !== null) {
        this.resetForm();
      }
    },
    resetForm() {
      this.startDisabled = false;
      this.taskRunsFlag = 0;
      this.resultLine = null;
      this.disableFlag = true;
      this.queueId = null;
      this.startAutoDownload = false;
      this.$store.commit("setFileNames", { files: null, userFiles: null });
    },
    createFormData(paramLine) {
      //для отправки на сервер
      const formData = new FormData();
      let command = {
        cmd: "runTask",
        body: paramLine,
        idTask: this.taskSelected.idTask,
        idSection: this.getCurInfo.id,
      };
      if (this.commentLine) {
        command.comment = this.commentLine;
      }
      const commandStr = JSON.stringify(command);
      // console.log(commandStr);
      formData.append("command", commandStr);

      this.filesArray.forEach((file) => {
        formData.append("upload", file);
      });
      return formData;
    },
    creatUpgFormData(filename, file, databaseName) {
      const formData = new FormData();
      let command = {
        cmd: "luaFunc",
        params: {
          script: "upgrade1",
          funcname: "run1",
          funcparam: {
            idTask: this.taskSelected.idTask,
            idSection: this.getCurInfo.id,
            body: filename,
          },
        },
      };
      if (databaseName !== "all_bases") {
        command.params.funcparam.database = databaseName;
      }
      if (this.commentLine) {
        command.params.funcparam.comment = this.commentLine;
      }
      const commandStr = JSON.stringify(command);
      formData.append("command", commandStr);
      formData.append("upload", file);
      return formData;
    },
    showLabel(element) {
      //    v-if="el.ftParam!=='ftConst' && el.ftParam !== 'ftAppHome' && el.ftParam !== 'ftAppName' && el.ftParam !=='ftBoolean'|| (fromCron && el.ftParam !== 'ftBaseName') || (fromCron && el.ftParam !== 'ftBaseShortName')"
      let param = element.ftParam;
      let arrayNotShow = ["ftConst", "ftAppHome", "ftAppName", "ftBoolean"];
      let arrayFromCron = ["ftBaseName", "ftShortBaseName"];
      if (arrayNotShow.includes(param)) {
        return false;
      } else if (this.fromCron && arrayFromCron.includes(param)) {
        return false;
      } else return true;
    },
    baseLabel(base) {
      let label = base.bname;
      if (base.balias && base.comment) {
        label += " (" + base.balias + ") -- " + base.comment;
      } else if (base.balias) label += " (" + base.balias + ")";
      else if (base.comment) label += " -- " + base.comment;
      return label;
    },
  },
  computed: {
    ...mapGetters([
      "getServersArray",
      "getBasesInSection",
      "getRTCmdLine",
      "getCurInfo",
      "getRTRetFile",
      "getTaskQueueId",
      "getUser",
      "getTypeApi", //для проверки правильности файла обновления
    ]),
  },
  components: {
    ResultLogButton,
    FilesSelect,
  },
};
</script>

<style scoped>
/* .main-content-rt {
  padding-bottom: 60px;
} */
.main-form-scroll {
  height: 30vh !important;
}

.dialog-btns {
  display: flex;
  justify-content: space-between;
  margin: 20px 0px 10px;
}

.dialog-btn {
  margin-left: 10px;
}

.all-buttons {
  padding-top: 5em;
}

.el-select {
  width: 100%;
}

.line {
  margin: 10px 0px;
}

.run-upg-button {
  margin-bottom: 30px;
  transform: scale(1.2);
  margin-left: 34px;
  margin-top: 10px;
}

.message-box {
  width: 90%;
  overflow-y: visible;
  background: red;
}

.task-text {
  font-size: 1.4em;
  text-align: center;
  font-weight: 500;
}

.upg-line {
  margin: 20px 0;
}

.error-message {
  color: darkred;
}

.success-message {
  color: darkgreen;
}

/* .form-scroll {
  min-height: 300px;
  overflow-y: auto;
} */
</style>